import BaseModelAPI from '../BaseModelAPI';

export default class PickingSupplyForProduction extends BaseModelAPI {
	static entity = 'pickingsupplyforproduction';
	static entityName = 'pickingsupplyforproduction';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.workOrderSupplyId = '';
			this.workOrderSupply = {};
			this.workOrderProcessId = '';
			this.workOrderProcess = {};
			this.workOrderSupplyDate = '';
			this.documentStatusId = '';
			this.documentStatus = {};
			this.lineId = '';
			this.line = {};
			this.pickingSupplyForProductionDetail = []
			this.pickingSupplyForProductionCase = []
			this.pickingSupplyForProductionSuggestion = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}